module.exports = __webpack_public_path__ + "static/img/slide-2.c92a800.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/slide-2.jpg
// module id = Y7ol
// module chunks = 1